import React from 'react';
import PropTypes from 'prop-types';

import './styles.scss';

const offer = props => {
  const { label, description, className } = props;

  return (
    <div className={'label offer ' + (className ? className : '')}>
      <strong>{label}</strong>
      {description}
    </div>
  );
};

offer.defaultProps = {
  description: '',
};

offer.propTypes = {
  label: PropTypes.string.isRequired,
  description: PropTypes.string,
};

export default offer;
